'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { User, RefreshCw, Home, ArrowLeft } from 'lucide-react'
import { getSafeTranslation } from '@/lib/i18n/LanguageContext'
import { Button } from '@/components/ui/button'

export default function ProfileError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const t = getSafeTranslation

  useEffect(() => {
    console.error('Profile error:', error)
  }, [error])

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
          <User className="w-8 h-8 text-blue-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {t('errors.errorBoundary.profileError')}
        </h1>

        <p className="text-gray-600 mb-6">
          {t('errors.errorBoundary.profileDescription')}
        </p>

        {error.digest && (
          <p className="text-sm text-gray-500 mb-6 font-mono bg-gray-100 py-2 px-3 rounded-lg inline-block">
            {t('errors.errorBoundary.errorId')}: {error.digest}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={reset}
            className="inline-flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            {t('errors.errorBoundary.tryAgain')}
          </Button>

          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('errors.errorBoundary.goBack')}
          </Button>

          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            <Home className="w-4 h-4" />
            {t('errors.errorBoundary.goHome')}
          </Link>
        </div>
      </div>
    </div>
  )
}
